import { Routes, Route, useLocation } from "react-router-dom";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AuthCallback from "@/pages/AuthCallback";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import BillingLockGuard from "@/components/BillingLockGuard";
import Dashboard from "@/pages/Dashboard";
import Rooms from "@/pages/Rooms";
import Guests from "@/pages/Guests";
import GuestScanner from "@/pages/GuestScanner";
import CalendarPage from "@/pages/CalendarPage";
import Alloggiati from "@/pages/Alloggiati";
import TouristTax from "@/pages/TouristTax";
import Reports from "@/pages/Reports";
import Properties from "@/pages/Properties";
import Companies from "@/pages/Companies";
import Billing from "@/pages/Billing";
import Settings from "@/pages/Settings";
import Privacy from "@/pages/Privacy";
import CookiePolicy from "@/pages/CookiePolicy";
import Compliance from "@/pages/Compliance";
import SelfCheckin from "@/pages/SelfCheckin";
import SelfCheckinPage from "@/pages/SelfCheckinPage";
import IstatC59 from "@/pages/IstatC59";
import IcalSync from "@/pages/IcalSync";
import ChannelManager from "@/pages/ChannelManager";
import AdminLayout from "@/pages/AdminPanel";
import HelpPage from "@/pages/HelpPage";
import QrPoster from "@/pages/QrPoster";

const guarded = (Page) => <BillingLockGuard><Page /></BillingLockGuard>;

export default function AppRoutes() {
  const location = useLocation();
  // Emergent Auth callback: catch session_id in URL fragment BEFORE ProtectedRoute runs
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />
      <Route path="/conformita" element={<Compliance />} />
      <Route path="/checkin/:token" element={<SelfCheckin />} />
      <Route path="/guida" element={<HelpPage />} />
      <Route path="/guide" element={<HelpPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      <Route path="/admin/*" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>} />

      <Route path="/app" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={guarded(Dashboard)} />
        <Route path="calendar" element={guarded(CalendarPage)} />
        <Route path="rooms" element={guarded(Rooms)} />
        <Route path="guests" element={guarded(Guests)} />
        <Route path="scanner" element={guarded(GuestScanner)} />
        <Route path="self-checkin" element={guarded(SelfCheckinPage)} />
        <Route path="alloggiati" element={<Alloggiati />} />
        <Route path="tourist-tax" element={guarded(TouristTax)} />
        <Route path="istat-c59" element={guarded(IstatC59)} />
        <Route path="ical-sync" element={guarded(IcalSync)} />
        <Route path="channel-manager" element={guarded(ChannelManager)} />
        <Route path="reports" element={guarded(Reports)} />
        <Route path="properties" element={guarded(Properties)} />
        <Route path="companies" element={guarded(Companies)} />
        <Route path="billing" element={<Billing />} />
        <Route path="settings" element={<Settings />} />
        <Route path="help" element={<HelpPage />} />
        <Route path="qr-poster" element={<QrPoster />} />
      </Route>
    </Routes>
  );
}
